import React from 'react';
import { Radio, Table, Modal, Input, Checkbox, Form, Button } from 'antd';
import withSpin from 'components/withSpin';
import SaveButton from 'components/SaveButton';

import axios from 'axios';
import apiPath from 'apiPath';



class Note extends React.Component {

    state = {
        visible: false,
        showRadio: false,
        note: null,
        checkbox: [],
        status: null,
    }

    showModal = (e) => {
        this.setState({
            visible: true,
            showRadio: e.target.value === 'Conditional Admit'
        });
    }

    handleCancel = (e) => {
        this.setState({
            visible: false,
        });
    }

    onChange = (e) => {
        this.setState({ checkbox: e })
    }

    handleSubmit = (event) => {
        this.props.isSubmitting();
        event.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (values.status === "Conditional Admit") {
                const submitData = {
                    statusType: this.props.noteType,
                    status: values.status + " " + this.state.checkbox,
                    statusNote: values.statusNote,
                }
                axios.post(apiPath + '/admissions/postAdmitShipStatus', submitData, { withCredentials: true }).then(result => {
                    this.props.getAdmitStatus();
                })
                this.handleCancel();
            } else {
                const submitData = {
                    statusType: this.props.noteType,
                    status: values.status,
                    statusNote: values.statusNote,
                }
                axios.post(apiPath + '/admissions/postAdmitShipStatus', submitData, { withCredentials: true }).then(result => {
                    this.props.getAdmitStatus();
                })
                this.handleCancel();
            }
        })
    }

    // getAdmitStatus = () => {
    //     axios.get(apiPath + '/admissions/getAdmitShipStatus', { withCredentials: true }).then(result => {
    //         console.log(result, "result")
    //         this.setState({status: 
    //             result.data.filter(res => {
    //                 return res.StatusType === 'admit'
    //             })
    //         })
    //     })
    // }

    componentDidMount() {
    }

    render() {
        const { getFieldDecorator, isFieldTouched } = this.props.form;
        const requiredRules = (this.props.required) ? [{ required: true }] : [];

        const columns = [{

            title: 'Status',
            dataIndex: 'Status',
            key: 'Status'
        },
        {
            title: 'Date',
            dataIndex: 'StatusDate',
            key: 'Date'
        },
        {
            title: 'Note',
            dataIndex: 'StatusNote',
            key: 'Note'
        },
        // {
        //     title: 'Written By',
        //     dataIndex: 'User',
        //     key: 'Written By'
        // }
    ];


        const value = this.props.value || '';

        return (

            <Form onSubmit={this.handleSubmit}>
                <Form.Item>
                    {getFieldDecorator('status', {
                        initialValue: ''
                    })(
                        <Radio.Group onChange={this.showModal}>
                            {this.props.statusOptions.map(option =>
                                <Radio.Button label={option.label} key={option.value} value={option.value}>{option.title}</Radio.Button>
                            )
                            }
                        </Radio.Group>
                    )}
                </Form.Item>

                {this.props.showTable &&
                    <Table rowKey={'Date'} dataSource={this.props.status} columns={columns} bordered={true} style={{ backgroundColor: 'white', marginTop: '20px' }} pagination={false} />
                }

                <Modal
                    title="Status Change Note"
                    visible={this.state.visible}
                    footer={null}
                    onCancel={this.handleCancel}

                >
                    <Form.Item>
                        {getFieldDecorator('statusNote', {
                            initialValue: this.state.note
                        })(
                            <Input />
                        )}
                    </Form.Item>
                    <Button
                        type="primary"
                        onClick={this.handleSubmit}
                        icon="save"> Save
                    </Button>
                </Modal>
            </Form>
        );
    }

}

export default withSpin(Form.create()(Note));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/Note.jsx